import { ConfigurationError } from '@cian/peperrors/shared'; // eslint-disable-next-line react/no-deprecated

import { loadableReady } from '@loadable/component';
import { hydrateRoot } from 'react-dom/client';

import { Application } from '@/app/shared/containers/Application';
import { type IApplicationContext } from '@/app/shared/types/ApplicationContext';
import { type MicrofrontendAliases } from '@/app/shared/types/MicrofrontendAliases';

import { type IQueryState } from '@/packages/query-state/shared/services/QueryState';
import { type IReduxStateProvider } from '@/packages/redux-state/ReduxState';

type Dependencies = {
  context: IApplicationContext;
  queryState: IQueryState;
  reduxState: IReduxStateProvider;
};

const domain = '@/browser/services/renderApplication/service.tsx';

export function renderApplication(dependencies: Dependencies): void {
  const { context, queryState, reduxState } = dependencies;
  const { config, logger } = context;

  const projectName = config.getStrict<string>('projectName');
  const mfAliases = config.getStrict<MicrofrontendAliases>('mfAliases');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    const configurationError = new ConfigurationError({ domain, message: `Unable to find element #${projectName}` });

    logger.error(configurationError.message, { domain: configurationError.domain });

    throw configurationError;
  }
  loadableReady(() => {
    hydrateRoot(
      rootElement,
      <Application context={context} mfAliases={mfAliases} queryState={queryState} reduxState={reduxState} />,
    );
  });
}
